// External dep.
import React from "react";
import Reflux from "reflux";
import { Redirect } from "react-router-dom";
import classNames from "classnames";
// Internal dep.
import logger from "../utils/LoggerFrontend";
import Actions from "../Actions";
import StatusStore from "../Stores/StatusStore";
import { Store__System } from "@talentbait/shared-components";
// Views
import LoadingView from "../Components/LoadingView/LoadingView.jsx";
// Module
export default class MediaCenter extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      filter: "",
      isLoadingMedia: false,
      searchTerm: "",
      sortBy: "statusSort",
      sortOrder: "DESC",
      mediaList: undefined,
      orgaData: undefined
    };
    this.stores = [Store__System, StatusStore];

    Actions.getHistoricImages.completed.listen((result) => {
      logger.debug("MediaCenter:getHistoricImages:completed", "called...", result);

      this.setState({
        isLoadingMedia: false,
        mediaList: result.payload && result.payload.images
      });
    });

    Actions.getHistoricImages.failed.listen((err) => {
      logger.debug("error:MediaCenter:getHistoricImages:failed", "called...", err);
      this.setState({
        isLoadingMedia: false,
        mediaList: []
      });
    });

    this.loadHandler = Actions.loadOrganization.completed.listen((orga) => {
      logger.debug("MediaCenter:loadHandler:completed", "called...", orga);
      //Actions.loadInvoices(orga.id);
      Actions.getHistoricImages({
        //companyName: "Stadt Aalen",
        orgaId: props.match.params.orgaId
        //orgaName: "Stadt Aalen"
      });

      this.setState({ isLoadingOrga: false, isLoadingMedia: true, orgaData: orga });
    });

    this.loadHandlerFailed = Actions.loadOrganization.failed.listen((err) => {
      logger.debug("error:MediaCenter:loadHandler:failed", "called...", {
        err
      });
      this.setState({ isLoadingOrga: false });
    });

    logger.debug("MediaCenter:constructor", "called...", props.match.params.orgaId);

    Actions.loadOrganization(props.match.params.orgaId);
  }
  componentWillUnmount() {
    this.loadHandler();
    this.loadHandlerFailed();
  }

  renderList() {
    const { mediaList, searchTerm } = this.state;

    var sortedArray = mediaList;
    this.sumBudget = 0;
    this.sumUnpaid = 0;

    var tr;

    if (sortedArray.length === 0 && searchTerm !== "") {
      tr = this.renderPlaceholder();
    } else {
      tr = this.renderRows(sortedArray);
    }

    if (mediaList) {
      return (
        <div>
          <h2 className="">
            <span>Rechnungsübersicht ({sortedArray.length})</span>
          </h2>
          <table className="dashboard__table">
            <thead>
              <tr className="table__top">
                <td className="table__td-tiny" />
                <td className="table__td-small">Rechnungsnummer</td>
                <td>Firmenname</td>
                <td>Buchung</td>
                <td className="table__td-small">Betrag</td>
                <td className="table__td-small">Erstellt</td>
                <td className="table__td-small">Status</td>
              </tr>
            </thead>
            <tbody>{tr}</tbody>
            <tfoot>
              <tr>
                <td className="table__td-clear" />
                <td className="table__td-clear" />
                <td className="table__td-clear" />
                <td className="right">
                  <strong>SUM {this.sumBudget.toFixed(2)}</strong> <br />
                  <span className="dashboard__text-light">Gesamtbetrag</span>
                </td>
                <td className="table__td-clear"></td>
                <td className="right">
                  <strong>SUM {this.sumUnpaid.toFixed(2)}</strong> <br />
                  <span className="dashboard__text-light">Zu bezahlen</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      );
    }
  }
  renderSortClass(field, small) {
    const { sortOrder, sortBy } = this.state;

    logger.debug("MediaCenter:renderSortClass", "renderSortClass...", field, sortOrder);
    return classNames({
      underline: true,
      active: sortBy === field,
      "table__td-clear": small,
      up: sortOrder === "ASC"
    });
  }

  showInput(e) {
    logger.debug("MediaCenter:showInput", "called...");

    this.setState({
      showCreate: true
    });
  }

  search(e) {
    this.setState({ searchTerm: e.target.value });
  }
  renderSearchBox() {
    const { searchTerm } = this.state;

    const classSearch = classNames({
      "dashboard__search-close": true,
      "dashboard__search-close--close": searchTerm == ""
    });

    return (
      <div className="dashboard__search">
        <input
          type="text"
          onChange={this.search}
          placeholder="Suchen"
          value={searchTerm}
          className="dashboard__search-field"
        />
        <div
          className={classSearch}
          onClick={() => {
            this.setState({ searchTerm: "" });
          }}
        >
          x
        </div>
      </div>
    );
  }

  render() {
    const { user, mediaList } = this.state;

    logger.debug("MediaCenter:render", "called: ", this.props);

    if (!user) {
      return <Redirect to="/login" />;
    }

    const orgaId = this.props.match.params.orgaId;

    logger.debug("MediaCenter:render", "orgaId: ", orgaId);

    if (!mediaList) {
      return <LoadingView msg="Lade Creatives..." showSpinner />;
    }

    return (
      <div className="">
        <section className="dashboard fade-in">
          <div>
            {this.renderSearchBox()}
            <h1>Media Center</h1>
          </div>
          <br />
          <div
            className="flex"
            style={{ maxWidth: "100%", width: "100%", flexWrap: "wrap", flexDirection: "row" }}
          >
            {this.state.mediaList.map((media) => {
              return (
                <div key={media.image_url}>
                  <img
                    style={{ maxWidth: 300, maxHeight: 300, marginRight: 20, marginBottom: 20 }}
                    src={media.image_url}
                    alt=""
                  />
                </div>
              );
            })}
          </div>
        </section>
      </div>
    );
  }
}
